import { render, staticRenderFns } from "./AddressOrderSummaryPanel.vue?vue&type=template&id=2c5e3de1&scoped=true&"
import script from "./AddressOrderSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./AddressOrderSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddressOrderSummaryPanel.vue?vue&type=style&index=0&id=2c5e3de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e3de1",
  null
  
)

export default component.exports